import React from 'react';
import { useIntl } from '@kyruus/intl';
import { messages } from 'Src/shared/messages';
import { IntlHelmet } from 'Src/utils/intl-helmet';

function MapSearchMetas({ search }) {
  const intl = useIntl();

  const getPageTitle = (search) => {
    if (!search.search_description) {
      return intl.formatMessage(messages.metaMapSearchPageTitleNoSearch);
    }
    return intl.formatMessage(messages.metaMapSearchPageTitle, {
      searchDescription: search.search_description
    });
  };

  return <IntlHelmet title={getPageTitle(search)} />;
}

export default MapSearchMetas;
